import { Component, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ResetPasswordService } from './reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;
  success = false;
  error: string | null = null;
  private code: string | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private resetPasswordService: ResetPasswordService
  ) {
    this.form = this.fb.group({
      password: ['', [
        Validators.required,
        Validators.minLength(6),
        this.passwordStrengthValidator()
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordsMatchValidator() });
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParamMap.get('code');
    if (!this.code) {
      this.error = "❌ Code de réinitialisation manquant.";
    }
  }

  onSubmit(): void {
    if (!this.code || this.form.invalid) return;
  
    const { password } = this.form.value;
    this.resetPasswordService.resetPassword(this.code, password).subscribe({
      next: () => {
        this.success = true;
  
        if (isPlatformBrowser(this.platformId)) {
          setTimeout(() => this.router.navigate(['/sign-in']), 3000);
        }
      },
      error: () => {
        this.error = "Une erreur est survenue. Veuillez réessayer.";
      }
    });
  }  

  private passwordsMatchValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: boolean } | null => {
      const password = group.get('password')?.value;
      const confirm = group.get('confirmPassword')?.value;
      return password && confirm && password !== confirm ? { passwordsMismatch: true } : null;
    };
  }

  private passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value || '';
      const hasUppercase = /[A-Z]/.test(value);
      const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(value);
      return !hasUppercase || !hasSpecial ? { passwordWeak: true } : null;
    };
  }
}
